 <template>
  <div class="home">
    <div id="layout-container">
      <search :search-tags="searchTags" :url-terms="searchTerms" />
      <div id="votes-container">
        <TransitionGroup name="votes" appear>
          <vote v-for="vote in filteredVotes" class="votes-item" :vote="vote" :key="vote.id" />
        </TransitionGroup>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

  .votes-item {
    transition: transform 2s, opacity 2s;
  }

  .votes-leave-active {
    opacity: 1;
  }

  .votes-enter, .votes-leave-to {
    opacity: 0;
  }

  #layout-container {
    width: 80vw;
    margin: 0 auto 24px;

    #votes-container {
      width: clamp(48%, 600px, 100%);
      margin: 0 auto;
    }
  }

</style>

<script>
import { voteData } from '@/data/votes.js'
import Search from '@/components/Search.vue'
import Vote from '@/components/Vote.vue'

export default {
  name: 'Home',

  components: {
    Search, Vote
  },

  props: [ 'searchTerms' ],
  
  data: () => ({
    votes: voteData,
    filteredVotes: [],
    searchTags: [],
    activeSearchTags: []
  }),
  
  methods: {
    makeSearchTags() {
      let tempTags = []
      this.votes.forEach((v) => {
        tempTags = [ ...tempTags, ...v.tags ]
      })
      this.searchTags = [ ...new Set(tempTags) ]
    },

    filterVotes() {
      if (!this.activeSearchTags.length) {
        this.filteredVotes = [ ...this.votes ]
        return
      }

      let votesToFilter = [ ...this.votes ]
      this.filteredVotes = votesToFilter.filter((v) => {
        //TODO: improve performance?
        return v.tags.some((vt) => {
          return (this.activeSearchTags.indexOf(vt) >= 0)
        })
      })
    },

    decodeSearchTerms() {
      if (!this.searchTerms) {
        this.activeSearchTags = []
        return
      }

      let terms = decodeURIComponent(this.searchTerms).split('|')

      this.activeSearchTags = terms.filter((t) => {
        return (this.searchTags.indexOf(t) >= 0)
      })
    },

    useSearchTerms() {
      this.decodeSearchTerms()
      this.filterVotes()
    },

    sortVotes() {
      this.votes = this.votes.sort((a,b) => {
        return (a.date > b.date) ? -1 : 1
      })
    }
  },

  watch: {
    searchTerms() {
      this.useSearchTerms()
    }
  },

  mounted() {
  },

  created() {
    this.sortVotes()
    this.makeSearchTags()
    this.useSearchTerms()
  }

}
</script>
